module.exports = __webpack_public_path__ + "static/assets/cb5107997ac2b252f6bfadb2c4968687.svg";